<div class="position-relative">
    <input #searchInput type="text" class="form-control" [class.is-invalid]="invalid()" [(ngModel)]="searchTerm"
        (input)="onInputChange()" (focus)="onFocus()" (blur)="onBlur()" (keydown)="onKeyDown($event)"
        [placeholder]="placeholder()" [disabled]="disabled()" [attr.aria-label]="ariaLabel()"
        autocomplete="off" />

    @if (this.searchTerm()) {
        <button
            class="btn btn-link position-absolute top-50 translate-middle-y end-0 me-2 p-0 border-0 bg-transparent input-group-clear-button"
            type="button" 
            (click)="clearSearch()"
            aria-label="Clear search">
            <fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg"/>
        </button>
    }

    @if (showDropdown()) {
        @if (serverSideSearch() && isSearching()) {
        <div class="dropdown-menu show" [style.width.px]="dropdownWidth()"
            [class.ms-typeahead-menu-in-modal]="isInsideModal()">
            <div class="dropdown-item text-muted">Searching…</div>
        </div>
        } @else if (filteredItems().length > 0) {
        <div class="dropdown-menu show" [style.width.px]="dropdownWidth()"
            [class.ms-typeahead-menu-in-modal]="isInsideModal()">
            @for (item of filteredItems(); track item.id || item.label; let i = $index) {
            <button type="button"
                class="dropdown-item"
                [class.active]="i === selectedIndex()"
                [class.disabled]="selectedItem() && item.id === selectedItem()?.id"
                [disabled]="selectedItem() && item.id === selectedItem()?.id"
                (mousedown)="selectItem(item)">
                {{ item.label }}
                @if (selectedItem() && item.id === selectedItem()?.id) {
                    <fa-duotone-icon icon="check" class="text-success ms-2" secondaryOpacity="0.9" size="sm"/>
                }
            </button>
            }

            @if (serverSideSearch() && hasMore()) {
                <div ms-in-view-port (inViewPort)="onLoadMore()"></div>
                @if (isLoadingMore()) {
                    <div class="dropdown-item text-muted text-center">Loading…</div>
                }
            }
        </div>
        } @else if (searchTerm().length >= minLength()) {
        <div class="dropdown-menu show" [style.width.px]="dropdownWidth()"
            [class.ms-typeahead-menu-in-modal]="isInsideModal()">
            <div class="dropdown-item">{{ noResultsText() }}</div>
        </div>
        }
    }
</div>
